import React from 'react'
import TextField from '../../../../ui/TextField.js'
import SexSelect from '../Inputs/SexSelect.js'
import AgeGroupSelect from '../Inputs/AgeGroupSelect.js'
import CountrySelect from '../Inputs/CountrySelect.js'

export default function FormPage1(props) {

    const consentHasError = !props.formData.consentCheck && props.formData.error.consentCheck === true;

    return (
        <div className="Form">
            <div className="Form--inputs-container">
                <div className="Form--inputs-section1">
                    <TextField
                        label="Nickname"
                        name="nickname"
                        autoComplete="nickname"
                        value={props.formData.nickname}
                        onChange={props.handleChange}
                        placeholder="e.g. John"
                        errorMessage="Please enter a nickname."
                        error={props.formData.error.nickname}
                    />
                    <TextField
                        label="Email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        value={props.formData.email}
                        onChange={props.handleChange}
                        placeholder="e.g. kizabo@gmail.com"
                        errorMessage="Please enter a valid email."
                        error={props.formData.error.email}
                    />
                </div>
                <p className="Form--instructions Form--instructions-page1">In order to improve our AI system, we kindly ask you to fill the following questions. We will keep this information anonymous.</p>

                <CountrySelect
                    label="Country"
                    name="country"
                    value={props.formData.country}
                    onChange={props.handleChange}
                    errorMessage="Please select your country."
                    error={props.formData.error.country}
                />
                <div className="Form--inputs-section2">
                    <SexSelect
                        label="Gender"
                        name="sex"
                        selectSexData={props.selectSexData}
                        handleSelectChange={props.handleSelectSexChange}
                        errorMessage="This is a required field."
                        error={props.formData.error.sexData}
                    />
                    <AgeGroupSelect
                        label="Age Group"
                        name="agegroup"
                        selectAgeGroupData={props.selectAgeGroupData}
                        handleSelectChange={props.handleSelectAgeGroupChange}
                        errorMessage="This is a required field."
                        error={props.formData.error.ageGroupData}
                    />
                </div>
                <div className="Form--inputs-section3">

                </div>
                <div className="Form--consent-section">
                    <input
                        className={`Form--consent-checkbox${consentHasError ? " is-error" : ""}`}
                        id="field-consentCheck"
                        name="consentCheck"
                        type="checkbox"
                        checked={props.formData.consentCheck}
                        onChange={props.handleChange}
                    />
                    <label className="Form--instructions" htmlFor="field-consentCheck">I consent to the collection and storage of my email and test answers. My results will be sent to my email in accordance with the <a href="https://kizabo.com/live-privacy-policy" target="_top">Privacy Policy</a>.</label>
                </div>
                            </div>
        </div>
    )
}